module.exports = __webpack_public_path__ + "img/Weapon_27.a079e29e.png";